import { AppContainer } from "./AppStyles";
import NavBar from "./components/NavBar/NavBar";
import Hero from "./components/Hero/Hero";
import Projects from "./components/Projects/Projects";
import Tools from "./components/Tools/Tools";
import TimeLine from "./components/TimeLine/TimeLine";
import Footer from "./components/Footer/Footer";
import ThemeManager from "./themes/themeManager";
import { projects, experimentalProjects } from "./constants/constants";

const App = () => {
  return (
    <ThemeManager>
      <AppContainer>
        <NavBar />
        <Hero />
        <Projects title={"Projects"} projects={projects} />
        <Projects title={"Experimental"} projects={experimentalProjects} />
        <Tools />
        <TimeLine />
        <Footer />
      </AppContainer>
    </ThemeManager>
  );
};

export default App;
